import serviceCostReportsApiService from '@/services/api/ServiceCostReports'

const emptyFilters = {
  yacht_id: null,
  created_at_from: null,
  created_at_to: null
}

export default class ServiceCostReport {
  static api = serviceCostReportsApiService
  static emptyFilters = emptyFilters
}
